
export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const ROOM_CODE_LENGTH = 6;

export const MAX_MESSAGE_BYTES = 32 * 1024;

export const MAX_UTTERANCE_CHARS = 600;

export const RATE_LIMIT_BURST = 60;
export const RATE_LIMIT_PER_SECOND = 20;

export const MAX_CLIENT_ID_LENGTH = 64;

export const STARTING_LIVES = 3;
export const PLAYERS_PER_ROOM = 2;

export const WORDS_PER_PLAYER = 3;

export const LIFE_LOSS_COOLDOWN_MS = 2000;

export const COUNTDOWN_MS = 3000;

export const FX_DELAY_MS = 250;

export const RECONNECT_GRACE_MS = 60_000;

export const ROOM_IDLE_EXPIRY_MS = 6 * 60 * 60 * 1000;
